import { writable } from 'svelte/store';

const piecesURL = __myapp.env.REQUESTS_BASE_URL;

export let showDialog = writable(false);
export let dialogType = writable(undefined);
export let dialogMessage = writable(undefined);
export let workListResponse = writable([]);
export const clearWorkList = () => workListResponse.set([]);

const getDate = () => {
    const current = new Date();
    const currentYear = current.getFullYear();
    current.setMonth(current.getMonth() - 1);

    if (current == -1 ) {
        current.setMonth(11);
    }

    const previousMonth = current.toLocaleString('default', { month: 'long' });

    return `${previousMonth}_${currentYear}`;
};

const serializeEmployee = (data) => {
    let body = {
        "employee_email": data.employee_email,
        "month": data.month,
        "year": data.year
    };

    return body;
};

export const getWorkList = async () => {
    const response = await fetch(
        `${piecesURL}/employees/` ,{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
            },
        }
    );

    if (!response.ok) {
        showDialog.set(true)
        dialogType.set("is-danger");
        dialogMessage.set("Nie możemy pobrać danych. Spróbuj ponownie.");
    };

    return response.json();
};


export const approve = async (data) => {
    const response = await fetch(
        `${piecesURL}/approve/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(serializeEmployee(data)),
    });

    if (!response.ok) {
        showDialog.set(true);
        dialogType.set("is-danger");
        dialogMessage.set("Nie możemy zaakceptować zgłoszenia. Spróbuj ponownie.");
    } else {
        const worklist = await getWorkList();
        workListResponse.set(worklist);
        showDialog.set(true);
        dialogType.set("is-primary");
        dialogMessage.set("Zgłoszenie zatwierdzone.");
    };
};

export const reject = async (data) => {
    const response = await fetch(
        `${piecesURL}/reject/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(serializeEmployee(data)),
    });

    if (!response.ok) {
        showDialog.set(true);
        dialogType.set("is-danger");
        dialogMessage .set("Nie możemy odrzucić zgłoszenia. Spróbuj ponownie.");
    } else {
        const worklist = await getWorkList();
        workListResponse.set(worklist);
        showDialog.set(true);
        dialogType.set("is-primary");
        dialogMessage.set("Zgłoszenie odrzucone.");
    };
};

export const sendNotification = async (data) => {
    const response = await fetch(
        `${piecesURL}/notifications/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(serializeEmployee(data)),
    });

    if (!response.ok) {
        showDialog.set(true);
        dialogType.set("is-danger");
        dialogMessage.set("Nie udało się wysłać powiadomienia. Spróbuj ponownie.");
    } else {
        const worklist = await getWorkList();
        workListResponse.set(worklist);
        showDialog.set(true);
        dialogType .set("is-primary");
        dialogMessage.set("Pracownik został powiadomony.");
    };
};


export const sendBulkNotifications = async (month, year) => {
    const numericMonth = Number(month);
    const numericYear = Number(year);

    const requestData = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
        body: JSON.stringify({
            month: numericMonth,
            year: numericYear,
        }),
    };

    try {
        const response = await fetch(`${piecesURL}/notifications/bulk/`, requestData);
        const contentType = response.headers.get("Content-Type") ?? "";
        const payload = contentType.includes("application/json")
            ? await response.json()
            : null;

        if (!response.ok) {
            throw new Error("bulk-notification-failed");
        }

        const worklist = await getWorkList();
        workListResponse.set(worklist);

        const failed = payload?.failed ?? [];
        const sent = payload?.sent ?? 0;

        if (failed.length > 0) {
            showDialog.set(true);
            dialogType.set("is-warning");
            dialogMessage.set(
                `Udało się wysłać ${sent} powiadomień, ` +
                `${failed.length} wysyłek nie powiodło się.`
            );
        } else {
            showDialog.set(true);
            dialogType.set("is-primary");
            dialogMessage.set(`Wysłano ${sent} powiadomień.`);
        }

        return true;
    } catch (error) {
        showDialog.set(true);
        dialogType.set("is-danger");
        dialogMessage.set("Nie udało się wysłać powiadomień. Spróbuj ponownie.");
        return false;
    }
};

const saveBlob = (data, user, type) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);

    const previousMonth = getDate();

    if (type === "employee") {
        link.download = `Karta pracownika_${user.employee_email}_${user.month}_${user.year}.pdf`;
    } else {
        link.download = `Karta utworu_${previousMonth}.pdf`;
    }

    link.click();
    URL.revokeObjectURL(link.href);
};

const saveArchive = (data, month, year) => {
    const blob = new Blob([data], { type: 'application/zip' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    const paddedMonth = String(month).padStart(2, '0');
    link.download = `Karty_pracownikow_${paddedMonth}_${year}.zip`;
    link.click();
    URL.revokeObjectURL(link.href);
};

export const generateEmployeeCardForMonth = async (employeeEmail, month, year) => {
    const payload = {
        employee_email: employeeEmail,
        month: Number(month),
        year: Number(year),
    };

    const requestData = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        },
        body: JSON.stringify(payload),
    };

    const response = await fetch(`${piecesURL}/pdf/`, requestData);

    if (!response.ok) {
        throw new Error('Failed to download employee card for selected month');
    }

    const blob = await response.blob();
    saveBlob(blob, payload, "employee");
};

export const generatePieceCard = async () => {
    const type = "piece"
    const requestData = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        },
    };

    return fetch(`${piecesURL}/pdf/pieces/`, requestData)
        .then(response => response.blob())
        .then(blob => saveBlob(blob, null, type));
};

export const generateBulkEmployeeCards = async (month, year) => {
    const numericMonth = Number(month);
    const numericYear = Number(year);

    const requestData = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        },
        body: JSON.stringify({
            month: numericMonth,
            year: numericYear
        }),
    };

    const response = await fetch(`${piecesURL}/pdf/bulk/`, requestData);

    if (!response.ok) {
        throw new Error('Failed to download employee cards');
    }

    const blob = await response.blob();
    saveArchive(blob, numericMonth, numericYear);
};

export const logout = () => {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    clearWorkList();
    window.location.href = __myapp.env.LOGIN_URL ?? window.location.origin;
};

export const reloadPieces = async (data) => {
    const button = document.getElementById(`reload-pieces-${data.employee_email}`);
    button.classList.add('is-loading');

    const requestData = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        },
        body: JSON.stringify(serializeEmployee(data)),
    };

    return fetch(`${piecesURL}/pieces/reload/`, requestData)
        .then(response => {
            if (response.ok) {
                showDialog.set(true);
                dialogType.set("is-primary");
                dialogMessage.set(`Udało się pobrać zadania dla ${data.employee_email}.`);
            } else {
                showDialog.set(true);
                dialogType.set("is-danger");
                dialogMessage.set("Nie udało się załadować zadań. Spróbuj ponownie.");
            }

            button.classList.remove('is-loading');
        })
}

export const getPiecesByMonth = async (month, year) => {
    const response = await fetch(
        `${piecesURL}/pieces/by-month/?month=${month}&year=${year}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
    });

    if (!response.ok) {
        showDialog.set(true);
        dialogType.set("is-danger");
        dialogMessage.set("Nie możemy pobrać danych o dziełach. Spróbuj ponownie.");
        throw new Error('Failed to fetch pieces');
    }

    return response.json();
};

export const getDatabaseTables = async () => {
    const response = await fetch(
        `${piecesURL}/data/tables/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
    });

    if (!response.ok) {
        showDialog.set(true);
        dialogType.set("is-danger");
        dialogMessage.set("Nie możemy pobrać listy tabel. Spróbuj ponownie.");
        throw new Error('Failed to fetch tables');
    }

    return response.json();
};

export const getTableData = async (tableName, limit = 100, offset = 0, month = null, year = null) => {
    let url = `${piecesURL}/data/${tableName}/?limit=${limit}&offset=${offset}`;
    if (month) {
        url += `&month=${month}`;
    }
    if (year) {
        url += `&year=${year}`;
    }
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
    });

    if (!response.ok) {
        showDialog.set(true);
        dialogType.set("is-danger");
        dialogMessage.set("Nie możemy pobrać danych z tabeli. Spróbuj ponownie.");
        throw new Error('Failed to fetch table data');
    }

    return response.json();
};

export const getJiraStatus = async () => {
    const response = await fetch(
        `${piecesURL}/jira/status/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to fetch Jira status');
    }

    return response.json();
};
